import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("khevora_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Normalise error detail to a safe string so components can render it
    // (FastAPI 422 returns an array of objects which crashes React if rendered).
    const d = err.response?.data?.detail;
    if (Array.isArray(d)) {
      err.response.data.detail = d.map((x) => x?.msg || x?.detail || JSON.stringify(x)).join(", ");
    } else if (d && typeof d === "object") {
      err.response.data.detail = d.msg || JSON.stringify(d);
    }
    if (err.response?.status === 401 && !window.location.pathname.includes("login")) {
      localStorage.removeItem("khevora_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
